import React, { useEffect, useState } from "react";
import userService from "../../../services/user.service";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { useDispatch } from "react-redux";
import { resetVideoLibraryInitialState } from "../../../Redux/Actions/VideoLibraryActions";
import {
  resetVideoLibraryDataTable,
  setDefaultColumnSet,
} from "../../../Redux/Actions/VideoLibraryDataTableActions";
import { getFromLocalStorage } from "../../../utils/webStorage";
import "./videoPlayer.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header/Header";
import Content from "./Content/Content";
import TableContainer from "./Table/TableContainer";
import {
  setBreakdownColumnSetData,
  setColumnSetStatusData,
} from "../../../Redux/Actions/ColumnSetAction";
import {
  setActiveBreakdownForColumnSetSelected,
  setSelectedColumnSet,
} from "../../../Redux/Actions/VideoLibraryDataTableActions";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import { useSelector } from "react-redux";
const VideoPlayer = () => {
  const [playing, setPlaying] = useState(true);
  const [isPaymentOverdue, setIsPaymentOverdue] = useState(false);
  const schoolId = getFromLocalStorage("schoolId");
  const dispatch = useDispatch();
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const [videoSettings, setVideoSettings] = useState({
    fullWidth: true,
    fullHeight: true,
  });

  useEffect(() => {
    userService
      .getDefaultBreakdownToBreakdown(schoolId)
      .then((response) => {
        userService.getAllBreakDownColumnData(schoolId).then((res) => {
          const { breakdownMap, columnNameList } = res?.data?.data;
          const currentColumnSet = columnNameList.filter(
            (el) => el.isDefaultColumn
          );
          setSelectedColumnSet(dispatch, {
            id: currentColumnSet[0]?.id,
            columnName: currentColumnSet[0]?.columnName,
          });
          setColumnSetStatusData(dispatch, columnNameList);
          setBreakdownColumnSetData(dispatch, breakdownMap);
          const newSortedData = breakdownMap[currentColumnSet[0]?.columnName][
            "activeBreakdowns"
          ].sort(
            (a, b) => parseInt(a.positionNumber) - parseInt(b.positionNumber)
          );
          const filteredActiveData = newSortedData.map((el) => ({
            ...el,
            id: el?.id.toString(),
          }));
          setActiveBreakdownForColumnSetSelected(dispatch, filteredActiveData);
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  }, []);

  useEffect(() => {
    userService.getBillingDetailsCheck(schoolId).then((res) => {
      const check = res.data.status;
      setIsPaymentOverdue(check);
    });
    return () => {
      resetVideoLibraryDataTable(dispatch);
      resetVideoLibraryInitialState(dispatch, {});
    };
  }, []);

  // State to manage zoom level
  const [zoomLevel, setZoomLevel] = useState(1); // Initial zoom level is 1 (normal size)

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => prevZoom * 1.02); // Increase zoom level by 2%
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => prevZoom / 1.02); // Decrease zoom level by 2%
  };

  return (
    <>
      <SchoolAdminDashboard />
      <div
        className={isDrawerOpen ? "content-layout" : "toggle-content-layout"}
        // style={{
        //   marginLeft: isDrawerOpen ? "240px" : "0px",
        //   paddingTop: !isDrawerOpen && "10px",
        // }}
      >
        <div className={`videoPlayer-container position-relative`}>
          <div className="videoPlayer">
            <Header
              videoSettings={videoSettings}
              setVideoSettings={setVideoSettings}
            />
            <Content
              zoomLevel={zoomLevel}
              playing={playing}
              setPlaying={setPlaying}
              videoSettings={videoSettings}
              setVideoSettings={setVideoSettings}
              currentVideoIndex={currentVideoIndex}
              setCurrentVideoIndex={setCurrentVideoIndex}
            />
            <TableContainer
              handleZoomIn={handleZoomIn}
              handleZoomOut={handleZoomOut}
              playing={playing}
              setPlaying={setPlaying}
              videoSettings={videoSettings}
              setVideoSettings={setVideoSettings}
              currentVideoIndex={currentVideoIndex}
              setCurrentVideoIndex={setCurrentVideoIndex}
            />
          </div>
          {isPaymentOverdue && (
            <div className="payment-overdue-container">
              <div className="payment-overdue-msg-box"></div>
              <div>
                <h2 className="disabledMessage bold">
                  Your Payment is overdue
                </h2>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VideoPlayer;
